import { Link } from 'react-router-dom'
import GetStartedCard from './GetStartedCard';
import './GetStarted.scss';
import { IconEdit, IconConnected } from '../../assets/icons';
import ConnectOBAccount from '../Account/ConnectOBAccount';
import ConnectPlaidAccount from '../Account/ConnectPlaidAccount';

const AccountsGetStarted = ({ launchConnect }) => {
    return (
        <>
            <div className="get-started-row">
                <GetStartedCard
                    title="Automatic Updates"
                    icon={<IconConnected style={{
                        width: "3rem",
                        height: "3rem",
                    }} />}
                    description="Securely connect your bank accounts to automatically refresh account balances and import transactions."
                    btnComponent={
                        <>
                            <ConnectOBAccount launchConnect={launchConnect} />
                            <ConnectPlaidAccount launchConnect={launchConnect} />
                        </>
                    }
                    flagText="Recommended"
                />

                <GetStartedCard
                    title="Manual Updates"
                    icon={<IconEdit style={{
                        width: "3rem",
                        height: "3rem",
                    }} />}
                    description="If you prefer, you can manually add your account information and update your account balances."
                    btnLink="/add-account"
                    btnClass="button button-slim button-green"
                    btnText="Manually Add Accounts"
                />
            </div>

            <p className="spc-m-t-1 text-center" style={{fontSize: "1rem", fontWeight: '300'}}>
                If you've already <Link to="/accounts">added an account</Link>, and you want the available balance to be factored into your budget, make sure to check the box labeled <span style={{fontWeight: 400}}>"Include in Budget Funds"</span>.
            </p>
        </>
    )
}

export default AccountsGetStarted